var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "187.95 93.98 59.68 82.96",
    className: "w-7 h-10 ",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188,105.28c0-7.23,2.66-11.3,8.19-11.3,4.23,0,6.17,2.44,7.17,5.41l-3.16,1.07c-.66-2-1.56-3.57-4-3.57-3.09,0-4.44,2.53-4.44,6.54v3.69c0,4,1.35,6.54,4.44,6.54,2.48,0,3.38-1.56,4-3.56l3.16,1.06c-1,3-2.94,5.41-7.17,5.41C190.61,116.57,188,112.51,188,105.28Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.15,116.2h-3.48V94.36h8.17c4.13,0,6.41,2.5,6.41,6.57,0,3.31-1.68,5.63-4.72,6.13l5,9.14h-3.88l-4.64-8.83h-2.9Zm4.19-11.64c2.19,0,3.25-1,3.25-3v-1.34c0-2-1.06-3-3.25-3h-4.19v7.29Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.65,116.2V94.36h13.67V97.3H236.15v6.35H246v2.94h-9.8v6.67h10.17v2.94Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188,129.34h6.51c5.53,0,8.23,3.82,8.23,10.92s-2.7,10.93-8.23,10.93H188Zm6.29,19c3.19,0,4.75-2.26,4.75-6.23v-3.63c0-4-1.56-6.23-4.75-6.23h-2.82v16.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M209.79,151.19v-2.66h5.14V132h-5.14v-2.66h13.77V132h-5.13v16.53h5.13v2.66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M247.42,151.19h-4L241,146.87l-2.32-4.13h-.18l-2.38,4.13-2.57,4.32H229.8L236.49,140l-6.28-10.64h4l2.22,3.91,2.25,4h.16l2.25-4,2.32-3.91h3.72L240.78,140Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 187.95,
    y: 173.94,
    width: 59.68,
    height: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.085d087b405a5a3bb4b4d57fc26f448f.svg";
export { ForwardRef as ReactComponent };